// Copyright 2022 Sorama B.V.

import { IBasicCredentials } from "libraries/WebRequestHandler/BasicHTTPAuthentication";
export abstract class ICamConnectionInfo implements IBasicCredentials {
    public readonly domain: string;
    public readonly username: string;
    public readonly password: string;
    public readonly port: string;
}
